import { render, staticRenderFns } from "./TrainingCourseCreate.vue?vue&type=template&id=5c3bbab1&"
import script from "./TrainingCourseCreate.vue?vue&type=script&lang=js&"
export * from "./TrainingCourseCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports